import * as React from "react";
function SvgViewPdf(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <g clipPath="url(#view-pdf_svg__clip0_3954_10507)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22 17.425V5.68a1.67 1.67 0 00-.488-1.179l-2.01-2.012A1.664 1.664 0 0018.327 2H8.68a1.664 1.664 0 00-1.665 1.668v6.086a.202.202 0 00.184.201c.412.043.817.129 1.21.258a.201.201 0 00.247-.096.203.203 0 00.024-.093v-5.94a.417.417 0 01.416-.416h9.056c.11 0 .216.043.294.121l1.767 1.77a.418.418 0 01.121.294v11.155a.417.417 0 01-.416.417h-7.59a.2.2 0 00-.192.141 5.75 5.75 0 01-.35.846.22.22 0 00.01.193l.382.382c.065.061.149.098.238.105h7.918A1.664 1.664 0 0022 17.425zM9.308 19.676l2.086 2.09a.832.832 0 001.411-.593.835.835 0 00-.233-.586l-2.087-2.09a.2.2 0 01-.025-.25 4.605 4.605 0 00-.992-6.058 4.586 4.586 0 00-6.12.329 4.602 4.602 0 002.492 7.79 4.585 4.585 0 003.215-.656.2.2 0 01.253.024zM6.6 18.703a2.91 2.91 0 01-2.691-1.801 2.923 2.923 0 01.631-3.18 2.912 2.912 0 014.974 2.063 2.92 2.92 0 01-.853 2.064 2.911 2.911 0 01-2.06.854zM19.4 8.385c0 .189-.11.384-.335.384h-.921v.816h.776c.24 0 .36.19.36.38 0 .194-.12.39-.36.39h-.776v1.21c0 .28-.16.435-.376.435s-.376-.155-.376-.434V8.434c0-.228.14-.434.39-.434h1.283c.22 0 .335.189.335.385zM13.792 8h.939c1.266 0 1.99.807 1.992 2.05 0 1.177-.77 1.939-1.935 1.939h-.985c-.186 0-.446-.1-.446-.42V8.43c0-.257.18-.431.435-.431zm.412 3.215h.572c.73 0 1.063-.531 1.063-1.203 0-.718-.34-1.239-1.12-1.239h-.515v2.442zM10.409 8h.93c.771 0 1.344.534 1.344 1.331 0 .814-.594 1.32-1.313 1.32h-.582v.915c0 .28-.168.434-.394.434S10 11.845 10 11.566V8.434c0-.262.146-.434.41-.434zm.379 1.917h.535c.33 0 .54-.257.541-.59 0-.335-.21-.592-.54-.592h-.536v1.182z"
                    fill="currentcolor"
                />
            </g>
            <defs>
                <clipPath id="view-pdf_svg__clip0_3954_10507">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgViewPdf);
export default ForwardRef;
